module.exports = __webpack_public_path__ + "3e9053927296f08c9b1fbbe2e1622818.png";